/* eslint-disable */
import type * as Types from '../client/types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type timesyncQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type timesyncQuery = { data: Types.Query['timesync'] };


export const timesync: DocumentNode<timesyncQuery, timesyncQueryVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timesync"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"timesync"}}]}}]};